module.exports = __webpack_public_path__ + "static/media/01B.55d8b886.png";